import type { ChatImagePayload } from '../../services/chatService';
import type { AssistantImage, UserImageUpload, WidgetMessage } from '../../types/chat';

export function getLastAssistantMessageIndex(messages: WidgetMessage[]): number {
    for (let i = messages.length - 1; i >= 0; i -= 1) {
        if (messages[i].role === 'assistant') {
            return i;
        }
    }

    return -1;
}

export function normalizeImageChunk(body: unknown): AssistantImage | null {
    if (typeof body !== 'object' || body === null) {
        return null;
    }

    const payload = body as Record<string, unknown>;
    const imageId = getString(payload.id) ?? getString(payload.imageId);
    const base64 = getString(payload.base64);
    const mimeType = getString(payload.mimeType) ?? 'image/png';

    if (!imageId || !base64) {
        return null;
    }

    return {
        id: imageId,
        base64,
        mimeType,
        hint: getString(payload.hint) ?? getString(payload.description),
        source: getString(payload.source) ?? getString(payload.sourcePath)
    };
}

export function getStatusDescription(body: unknown): string {
    if (typeof body === 'string') {
        return body.trim();
    }

    if (body && typeof body === 'object') {
        const record = body as Record<string, unknown>;
        const description = typeof record.description === 'string' ? record.description.trim() : '';
        const status = typeof record.status === 'string' ? record.status.trim() : '';

        return description || status;
    }

    return '';
}

export function shouldLogStatusUpdate(previousStatus: string, nextStatus: string): boolean {
    if (!previousStatus.trim().length) {
        return true;
    }

    return !nextStatus.startsWith(previousStatus);
}

export function mapUserImage(image: UserImageUpload): ChatImagePayload {
    return {
        id: image.id,
        fileName: image.fileName,
        mimeType: image.mimeType,
        base64Body: image.base64,
        sizeBytes: image.sizeBytes
    };
}

function getString(value: unknown): string | undefined {
    return typeof value === 'string' && value.trim().length > 0 ? value : undefined;
}
